// src/components/ProductCard.js
import React from "react";
import { useNavigate } from "react-router-dom";

const ProductCard = ({ product, onDelete }) => {
  const navigate = useNavigate();
  const isDeleted = (product.is_traceable === 0 || product.is_traceable === false);

  return (
    <div className={`admin-batch-card ${isDeleted ? "soft-deleted" : ""}`}>
      <div className="batch-details">
        <p><strong>Product Code:</strong> {product.product_code}</p>
        <p><strong>Name:</strong> {product.product_name}</p>
        <p><strong>Shelf Life:</strong> {product.shelf_life} months</p>
        <p><strong>Net Weight:</strong> {product.net_weight}</p>
        <p><strong>Brand:</strong> {product.brand || "N/A"}</p>
      </div>

      <div className="button-group">
       
        {!isDeleted && (
          <button
            className="edit-button"
            onClick={() => navigate(`/admin/edit-product/${product.product_code}`)}
          >
            Edit Product
          </button>
        )}
      </div>
    </div>
  );
};

export default ProductCard;
